import React, { useEffect, useState, useRef } from "react";

import {
    Text,
    View,
    TouchableOpacity,
    Platform,
    StyleSheet,
    ActivityIndicator,
    Modal,
    ScrollView,
    Linking,
    Image,
    TextStyle
} from "react-native";

import Main from "../../../specific/components/Main/Main";
import MainOptions from "../../models/MainOptions";
import Images from "../../../specific/utils/Images";

import AppTheme from "../../utils/Theme";
import Style from "../../utils/Style";
import * as DateUtils from "../../utils/DateUtils";

import i18n, { translate } from "../../utils/Localization/Localization";

import SVGView from "../../utils/SvgView";
import { default as IcHeart } from "../../assets/svg/icons/solid/heart.svg";
import { default as IcGift } from "../../assets/svg/icons/solid/gift.svg";
import { default as IcDownload } from "../../assets/svg/icons/solid/download.svg";
import { default as IcBan } from "../../assets/svg/icons/solid/ban.svg";
import { default as IcMask } from "../../assets/svg/icons/solid/mask.svg";
import { default as IcSignOut } from "../../assets/svg/lili/ic_logout.svg";
import { default as IcLiliStar } from "../../assets/svg/lili/ic_star.svg";
import { default as IcRainbow } from "../../assets/svg/lili/ic_rainbow.svg";
import { default as IcFilter } from "../../assets/svg/lili/ic_filter.svg";


// DATA
import * as Constants from "../../utils/Constants";

// Services
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import { signOut } from "../../services/Auth";
import { addSubToUser, deleteUser, getCardWithCode, redeemedPremiumCardInDb, revokeDBListeners } from "../../services/Firebase/Database";
import { wipeData } from "../../utils/LocalStorage";
import { EventRegister } from "../../utils/EventListeners";

import User from "../../data/user/User";
import { useNavigate } from "../../../specific/utils/Navigation/Navigation";
import Alert from "../Notification/Alert";
import RainbowPoints from "../UserRewards/RainbowPoints";
import { wipeLocalStorage } from "../../../specific/utils/LocalStorage";
import { analyctisEventPageViewed, analyticsEventPaywallDisplayed, deleteAnalyticsUserData, propertiesEventProfile, propertiesEventScreenLabel, propertiesEventSource, trackEvent } from "../../services/Tracking/Analytics";
import { logoutUser } from "../Splashcreen/Splashscreen";
import { AppTarget, getAppTarget } from "../../../specific/utils/Navigation/Host";
import Button from "../../designSystem/Button";
import TextInput from "../../designSystem/TextInput/RoundCornerTextInput";
import { PremiumCard } from "../LiliHQ/LHQCreateCode";
import UserLevelSelection from "../Filters/UserLevelSelection";
import NavBarButton from "../NavBar/NavBarButton";
import NavBarTitle from "../NavBar/NavBarTitle";
import { logoutGARUser } from "../../../specific/components/Authentication/TNE/Auth";
import Divider from "../../designSystem/Divider/Divider";
import { IcArobas, IcStar } from "../../utils/Icons";
import { openUrl } from "../../utils/WebLink";
import { AsyncStorageKey, getItemFromAsyncStorage } from "../../utils/AsyncStorage/AsyncStorage";

const favoritesCell = {
    id: 'favorites',
    title: i18n.t('profile.myFavorites'),
    icon: IcHeart,
    color: "#bba9fc"
};

const emptyCell = { id: "empty" };

const downloadCell = {
    id: 'downloads',
    title: i18n.t('profile.myDownloads'),
    icon: IcDownload,
    color: "#42bc99"
};

const deleteAccountCell = {
    id: 'delete',
    title: i18n.t('profile.deleteMyAccount'),
    icon: IcBan,
    color: "#DC143C"
};

interface UserProfileProps {
    componentId: string;
}

const UserProfile = (props: UserProfileProps) => {
    const { componentId = "" } = props;
    let navigate: any = null;
    let host = "app.lili.cool";
    if (Platform.OS === "web") {
        navigate = useNavigate();
        host = window.location.hostname;
    }
    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const userInstance: User = User.getInstance();
    const alertRef = useRef<Alert>(null);

    const [viewDidAppear, setViewDidAppear] = useState(false);
    const isTeacher = userInstance.isTeacher();
    const [user, setUser] = useState(userInstance.getUserData());
    const [refresh, setRefresh] = useState(0);
    const [mood, setMood] = useState("happy");
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const [filterByLevel, setFilterByLevel] = useState<null | { filter: string, last_update: number }>(null);
    const [showPremiumCardForm, setShowPremiumCardForm] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [premiumCode, setPremiumCode] = useState<string>("");
    const [premiumCodeError, setPremiumCodeError] = useState<string>("");
    const [premiumCodeRedeemed, setPremiumCodeRedeemed] = useState<boolean>(false);

    const listWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? (appTheme.getFullAppWidth() - appTheme.pixelPerfect(160)) / 2 : appTheme.getBlockWidth();
    const cellWidth: number = listWidth - appTheme.pixelPerfect(20);

    const imagesByMood = {
        "happy": images.icMoodHappy,
        "angry": images.icMoodAngry,
        "annoyed": images.icMoodAnnoyed,
        "calme": images.icMoodCalme,
        "sad": images.icMoodSad,
        "stressed": images.icMoodStressed
    }

    useEffect(() => {
        EventRegister.addEventListener(Constants.EventFiltersByLevelChanged, () => {
            getActiveFiltersByLevel();
        });
        EventRegister.addEventListener(Constants.EventUserAuthDB, () => {
            const userData = userInstance.getUserData();
            setUser(userData);
            setRefresh(new Date().getTime());
        });
        EventRegister.addEventListener(Constants.EventMoodFromProfileSelected, () => {
            getMood();
        });
        EventRegister.addEventListener("userUpdated", () => {
            const userData = userInstance.getUserData();
            setUser(userData);
            setRefresh(new Date().getTime());
        });

        return () => {
            EventRegister.removeEventListener(Constants.EventUserAuthDB);
            EventRegister.removeEventListener(Constants.EventMoodFromProfileSelected);
            EventRegister.removeEventListener(Constants.EventFiltersByLevelChanged);
            EventRegister.removeEventListener("userUpdated");
        };
    }, []);

    const getMood = async () => {
        const userMoodData: { data: any; ts: number } | null = await getItemFromAsyncStorage({ itemKey: AsyncStorageKey.mood });
        if (userMoodData !== null) {
            setMood(userMoodData.data);
        }
    }

    const checkSub = async () => {
        if (userInstance.getPremiumStatus() === "free") {
            if (Platform.OS === "web") {
                if ((host === "app-tne.lili.cool") || (host === "app-tne-demo.lili.cool")) {
                    // To do : Check sub from GAR
                }
            } else {
                await userInstance.getUserSubForRC();
                const userData = userInstance.getUserData();
                setUser(userData);
                setRefresh(new Date().getTime());
            }
        }
    }

    const openItem = (item: any, isUserSubscriber: boolean) => {
        if (item.id === "account") {
            let showSubPage: boolean = true;
            if (Platform.OS === 'web') {
                const appTarget: AppTarget = getAppTarget();
                if (appTarget !== "public") {
                    showSubPage = false;
                    isCas = true;
                }
            }
            if (showSubPage === true) {
                trackEvent(analyticsEventPaywallDisplayed, { [propertiesEventSource]: "user_profile", [propertiesEventProfile]: user.userProfile() });
                if (props.stripe !== undefined) {
                    Navigation.push({
                        componentId,
                        navigate,
                        name: Constants.ScreenStripeCallback,
                        passProps: {
                            status: props.stripe.status,
                            subId: props.stripe.subId
                        }
                    });
                } else {
                    Navigation.push({
                        componentId,
                        navigate,
                        name: Constants.ScreenSubscription,
                        passProps: {
                            isTeacher,
                            status: "profile"
                        }
                    });
                }
            }
        } else if (item.id === "delete") {
            alertRef.current?.showAlert({
                title: "Suppression de votre compte",
                body: "Vous allez supprimer votre compte, ainsi que tout votre historique.\nVoulez-vous continuer ?",
                primaryButtonTitle: "Confirmer",
                onPressPrimaryButton: deleteUserAccount,
                secondaryButtonTitle: "Annuler"
            });
        } else if (item.id === "logout") {
            alertRef.current?.showAlert({
                title: "Déconnexion",
                body: "Voulez-vous continuer ?",
                primaryButtonTitle: "Confirmer",
                onPressPrimaryButton: onSignOutRequest,
                secondaryButtonTitle: "Annuler"
            });
        } else if (item.id === "mood") {
            Navigation.showModalInView({
                componentId,
                name: Constants.ScreenMood,
                passProps: {
                    context: "userProfile"
                }
            });
        } else if (item.id === "favorites") {
            Navigation.push({
                componentId,
                navigate,
                name: Constants.ScreenUserFavorites
            });
        } else if (item.id === "badges") {
            Navigation.push({
                componentId,
                navigate,
                name: Constants.ScreenUserRewards
            });
        } else if (item.id === "downloads") {
            if (isUserSubscriber === false) {
                let title = "Compte premium seulement";
                let body = "Le téléchargement des activités est réservé aux comptes Premium.";
                alertRef.current?.showAlert({
                    title,
                    body,
                    onPressPrimaryButton: () => openItem({ id: "account" }, isUserSubscriber)
                });
            } else {
                Navigation.push({
                    componentId,
                    navigate,
                    name: Constants.ScreenUserDownloads
                });
            }
        } else if (item.id === "gift") {
            setShowPremiumCardForm(true);
        } else if (item.id === "admin") {
            Navigation.push({
                componentId,
                navigate,
                name: Constants.ScreenSuperAdmin
            });
        } else if (item.id === "filtersByLevel") {
            setShowFilters(true);
        }
    }

    const deleteUserAccount = async () => {
        try {
            await deleteUser({ user_id: user.uid });
            await deleteAnalyticsUserData();
            logout();
        } catch (error) {
            if (error.toString().includes("auth/requires-recent-login") === true) {
                alertRef.current?.showAlert({
                    title: "Suppression de votre compte",
                    body: "Par mesure de sécurité, nous avons besoin que vous confirmier l'e-mail et le mot de passe du compte à supprimer, en vous connectant à nouveau.",
                    onPressPrimaryButton: logout
                });
            } else {
                alertRef.current?.showAlert({
                    title: "Erreur lors de la suppression de votre compte",
                    body: "Veuillez réessayer s'il vous plaît ou non contacter à : support@lili.cool"
                });
            }
        }
    }

    const launchSubscriptionPage = () => {
        Navigation.push({
            componentId,
            navigate,
            name: Constants.ScreenSubscription,
            passProps: {
                isTeacher: user.profile === "teacher",
                status: "profile"
            }
        });
    }

    const AccountCell = () => {
        const sub_elements_style: TextStyle = { color: appTheme.darkBlue, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }
        let subExpireDateView: React.JSX.Element = <View />;
        let subscriptionPrefix: string = userInstance.profile === "family" ? translate.labels().profile.abo_family : userInstance.profile === "teacher" ? translate.labels().profile.abo_teacher : translate.labels().profile.abo_animator;
        let subscriptionDescription: string = userInstance.demo !== undefined ? translate.labels().profile.demoVersion : translate.labels().profile.freeVersion;
        let formulaTitleDecoration: React.JSX.Element = <View style={{ width: appTheme.pixelPerfect(20), marginEnd: appTheme.pixelPerfect(10) }} />;

        let formulaBlock: React.JSX.Element[] = [];
        if (userInstance.getPremiumStatus() !== "free") {
            const expireDate: number = ((userInstance.sub !== undefined) && (userInstance.sub.expires_date !== undefined)) ? userInstance.sub.expires_date : new Date().getTime();
            let subExpireDateText = i18n.t("profile.subAvailability");
            if (userInstance.sub.origin === "gar") {
                const endYear = new Date(expireDate).getFullYear();
                const startYear = endYear - 1;
                const schoolYear = startYear.toString() + " / " + endYear.toString();
                subExpireDateText = i18n.t("profile.subYearAvailability", { year: schoolYear });
            }
            formulaTitleDecoration = <View style={{ borderRadius: appTheme.pixelPerfect(10), height: appTheme.pixelPerfect(20), width: appTheme.pixelPerfect(20), backgroundColor: appTheme.premium, marginEnd: appTheme.pixelPerfect(10), justifyContent: "center", alignItems: "center" }}>
                <SVGView Component={IcStar} size={16} color={appTheme.white} />
            </View>;
            subExpireDateView = <Text style={[{ fontSize: appTheme.pixelPerfectForFont(5), fontFamily: appTheme.secondaryFont, color: appTheme.darkBlue }]}>{subExpireDateText}</Text>;
            subscriptionDescription = translate.labels().profile.premiumVersion;
            formulaBlock.push(<View key="premium_duration" style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <View style={{ flexDirection: "row", width: "100%" }}>
                    <View style={{ flex: 1 }}>
                        <Text style={sub_elements_style}>{translate.labels().profile.duration}</Text>
                    </View>
                    <View style={{ flex: 1, alignItems: "flex-end" }}>
                        <Text style={sub_elements_style}>{`${DateUtils.monthDiff(userInstance.sub?.start_date, userInstance.sub?.expires_date)} ${translate.labels().profile.months}`}</Text>
                    </View>
                </View>
            </View>);
            formulaBlock.push(<View key="premium_expire_date" style={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <View style={{ flexDirection: "row", width: "100%" }}>
                    <View style={{ flex: 1 }}>
                        <Text style={sub_elements_style}>{translate.labels().profile.subAvailability}</Text>
                    </View>
                    <View style={{ flex: 1, alignItems: "flex-end" }}>
                        <Text style={sub_elements_style}>{`${DateUtils.getNumericDateForTimestamp(userInstance.sub?.expires_date)}`}</Text>
                    </View>
                </View>
            </View>);
            if (userInstance.sub?.auto_renewing === false) {
                const legalText: string = userInstance.profile === "teacher" ? translate.labels().profile.teacher_non_renewable : "";
                formulaBlock.push(<View key="renewable" style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: appTheme.pixelPerfect(4) }}>
                    <Text style={{ fontFamily: appTheme.primaryFont, fontSize: appTheme.pixelPerfectForFont(5), color: appTheme.darkBlue, textAlign: "center" }}>{legalText}</Text>
                </View>);
            }
            /*
            formulaBlock.push(<TouchableOpacity key="info_button" style={{ marginTop: appTheme.pixelPerfect(10), justifyContent: "center", backgroundColor: "#FFD77A", padding: appTheme.pixelPerfect(4), borderRadius: appTheme.pixelPerfect(15), height: appTheme.pixelPerfect(30) }}>
                <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(5), color: appTheme.darkBlue, textAlign: "center" }}>{"Voir le détail de ma formule"}</Text>
            </TouchableOpacity>)
            */

            formulaBlock = [<View style={{ width: "80%" }}>
                {formulaBlock}
            </View>];
        } else {
            const buttonWidth: number | string = Platform.OS === "web" ? appTheme.pixelPerfect(240) : "100%";
            formulaBlock.push(<TouchableOpacity onPress={launchSubscriptionPage} key="subscribe_button" style={{ width: buttonWidth, flexDirection: "row", marginTop: appTheme.pixelPerfect(10), alignItems: 'center', justifyContent: "flex-start", backgroundColor: "#FFD77A", padding: appTheme.pixelPerfect(4), borderRadius: appTheme.pixelPerfect(15), height: appTheme.pixelPerfect(30) }}>
                <View style={{ borderRadius: appTheme.pixelPerfect(10), height: appTheme.pixelPerfect(20), width: appTheme.pixelPerfect(20), backgroundColor: appTheme.premium, marginEnd: appTheme.pixelPerfect(10), justifyContent: "center", alignItems: "center" }}>
                    <SVGView Component={IcStar} size={16} color={appTheme.white} />
                </View>
                <View style={{ flex: 1, alignItems: "center" }}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(5), color: appTheme.darkBlue, textAlign: "center" }}>{"Souscrire à Lili Premium"}</Text>
                </View>
            </TouchableOpacity>);
            formulaBlock.push(<TouchableOpacity onPress={() => setShowPremiumCardForm(true)} key="code_button" style={{ width: buttonWidth, flexDirection: "row", marginTop: appTheme.pixelPerfect(10), alignItems: 'center', justifyContent: "flex-start", backgroundColor: "#FFD77A", padding: appTheme.pixelPerfect(4), borderRadius: appTheme.pixelPerfect(15), height: appTheme.pixelPerfect(30) }}>
                <View style={{ borderRadius: appTheme.pixelPerfect(10), height: appTheme.pixelPerfect(20), width: appTheme.pixelPerfect(20), backgroundColor: appTheme.premium, marginEnd: appTheme.pixelPerfect(10), justifyContent: "center", alignItems: "center" }}>
                    <SVGView Component={IcStar} size={16} color={appTheme.white} />
                </View>
                <View style={{ flex: 1, alignItems: "center" }}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(5), color: appTheme.darkBlue, textAlign: "center" }}>{"Activer mon code Premium"}</Text>
                </View>
            </TouchableOpacity>);
            formulaBlock = [<View style={{ width: "80%", alignItems: "center" }}>
                {formulaBlock}
            </View>];
        }
        let emailAndNameString = "";
        if (((user.firstname.length > 0) && (user.lastname.length > 0))) {
            emailAndNameString = user.firstname + " " + user.lastname.toLocaleUpperCase();
        }
        if ((user.email.length > 0) && (user.email !== "noreply")) {
            if (emailAndNameString.length > 0) {
                emailAndNameString = emailAndNameString + " - ";
            }
            emailAndNameString = emailAndNameString + user.email;
        }
        const nameView = (emailAndNameString.length > 0) ? <Text style={[{ fontFamily: appTheme.secondaryFont, color: appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(8) }]}>{emailAndNameString}</Text> : <View />;
        return <View style={[styles.cell, { width: cellWidth, borderRadius: appTheme.pixelPerfect(20), marginBottom: appTheme.pixelPerfect(10) }]}>
            <View style={{ flexDirection: "row", alignItems: "center", width: "100%" }}>
                <Image source={userInstance.profile === "teacher" ? images.icLiliAtSchoolCircle : userInstance.profile === "family" ? images.icLiliAtHomeCircle : images.icLiliAtExtracurricularCircle} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50) }} />
                <View style={{ flex: 1 }}>
                    <Text style={{ textAlign: "center", fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(8), color: appTheme.darkBlue }}>
                        {translate.labels().profile.myAccount.toLocaleUpperCase()}
                    </Text>
                </View>
                <Image source={userInstance.profile === "teacher" ? require("../../assets/img/profile/ic_chouette_lae.png") : require("../../assets/img/profile/ic_chouette_lam_lep.png")} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50) }} />
            </View>
            <Divider />
            <View style={{ width: "100%", alignItems: "center" }}>
                {nameView}
            </View>
            <Divider />
            <View style={{ borderWidth: 1, borderRadius: appTheme.pixelPerfect(14), alignItems: "center", borderColor: "#FFD77A", paddingVertical: appTheme.pixelPerfect(10), width: "100%" }}>
                <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    {formulaTitleDecoration}
                    <Text style={{ textAlign: "center", fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(8), color: appTheme.darkBlue }}>
                        {translate.labels().profile.myFormule.toLocaleUpperCase()}
                    </Text>
                    <View style={{ width: appTheme.pixelPerfect(20), marginEnd: appTheme.pixelPerfect(10) }} />
                </View>
                <Divider />
                <Text style={{ textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7), color: appTheme.premium }}>
                    {`${subscriptionPrefix} ${subscriptionDescription}`}
                </Text>
                <Divider />
                {formulaBlock}
            </View>
        </View>
    }

    const aboutCell = ({ item, index }) => {

        const fullWidthForCell = listWidth - appTheme.pixelPerfect(20);

        let cell = [];
        for (const aCellIndex in item) {
            if (Object.prototype.hasOwnProperty.call(item, aCellIndex)) {
                const aCell = item[parseInt(aCellIndex)];
                const cellWidth = item.length === 1 ? fullWidthForCell : fullWidthForCell / 2 - appTheme.pixelPerfect(5);
                let cellPaddingBottom = 0;
                let isUserSubscriber = userInstance.getPremiumStatus() !== "free";
                if (aCell.id === "empty") {
                    cell.push(<View style={{ width: cellWidth, marginBottom: appTheme.pixelPerfect(20), justifyContent: 'center', alignItems: 'center', borderRadius: appTheme.pixelPerfect(20), marginHorizontal: appTheme.pixelPerfect(5) }} />);
                } else if (aCell.id === "delete") {
                    cell.push(<TouchableOpacity accessibilityRole="button"
                        accessible={true}
                        accessibilityLabel={aCell.title}
                        onPress={() => openItem(aCell, isUserSubscriber)}>
                        <Text style={{ textDecorationLine: "underline", color: user.profile === "family" ? appTheme.white : appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(6), fontFamily: appTheme.primaryBoldFont }}>
                            {aCell.title}
                        </Text>
                    </TouchableOpacity>)
                } else {
                    let cellHeight = item.length === 1 ? appTheme.pixelPerfect(60) : appTheme.pixelPerfect(100);
                    let horizontalAlign = item.length === 1 ? "flex-start" : "flex-end";
                    let iconStyle = { flex: 1, justifyContent: "center" };
                    if (item.length === 1) {
                        iconStyle = { width: appTheme.pixelPerfect(40), justifyContent: "center" };
                    }
                    const cellFlexDirection = item.length === 1 ? "row" : "column";
                    const cellPaddingTop = item.length === 1 ? appTheme.pixelPerfect(5) : appTheme.pixelPerfect(10);
                    cellPaddingBottom = item.length === 1 ? appTheme.pixelPerfect(5) : 0;
                    const cellTextAlign = item.length === 1 ? "left" : "center";
                    const cellTextFontSize = item.length === 1 ? appTheme.pixelPerfectForFont(12) : appTheme.pixelPerfectForFont(6);
                    const cellIconSize = item.length === 1 ? appTheme.pixelPerfect(24) : appTheme.pixelPerfect(24);
                    let subtitleView = <View />;
                    let subscribeButton = <View />;

                    let iconView = <View style={iconStyle}>
                        <View style={{ width: appTheme.pixelPerfect(40), height: appTheme.pixelPerfect(40), borderRadius: appTheme.pixelPerfect(20), backgroundColor: aCell.color, justifyContent: "center", alignItems: "center" }}>
                            <SVGView Component={aCell.icon} size={cellIconSize} color={appTheme.white} />
                        </View>
                    </View>;

                    if (aCell.id === "gift") {
                        const cellSize = (cellWidth - cellIconSize - appTheme.pixelPerfect(60));
                        cellHeight = appTheme.pixelPerfect(80);
                        subtitleView = <View>
                            <Text numberOfLines={2} style={[{ width: cellSize, fontFamily: appTheme.secondaryFont, color: appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(8) }]}>{i18n.t("profile.subCardsBody")}</Text>
                        </View>
                    }
                    if (aCell.id === "filtersByLevel") {
                        if (filterByLevel === null) {
                            subtitleView = <ActivityIndicator color={appTheme.schoolColor} />;
                        } else {
                            const { filter } = filterByLevel;
                            const cellSize = (cellWidth - cellIconSize - appTheme.pixelPerfect(60))
                            const filtersSelectedText = Constants.levels[filter];
                            subtitleView = <View >
                                <Text style={[{ fontFamily: appTheme.secondaryFont, color: appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(8), width: cellSize }]}>{filtersSelectedText}</Text>
                            </View>
                        }
                    }
                    let textColor = appTheme.darkBlue;
                    let backgroundColor = appTheme.white;
                    if (aCell.id === "mood") {
                        iconView = <View style={{ width: appTheme.pixelPerfect(56), height: appTheme.pixelPerfect(56), borderRadius: appTheme.pixelPerfect(28), backgroundColor: appTheme.daySkyColor, justifyContent: "center", alignItems: "center" }}>
                            <Image source={imagesByMood[mood]} style={{ width: appTheme.pixelPerfect(30), height: appTheme.pixelPerfect(30) }} resizeMode="contain" />
                        </View>;
                    } else if (aCell.id === "badges") {
                        iconView = <RainbowPoints onPress={() => openItem(aCell, isUserSubscriber)} user={user} userProfile={true} />
                    } else if ((aCell.id === "downloads") && (isUserSubscriber === false)) {
                        iconView = <View style={{ width: appTheme.pixelPerfect(40), height: appTheme.pixelPerfect(40), borderRadius: appTheme.pixelPerfect(20), backgroundColor: aCell.color, justifyContent: "center", alignItems: "center" }}>
                            <SVGView Component={IcLiliStar} size={cellIconSize} color={appTheme.white} />
                        </View>;
                    } else if (aCell.id === "admin") {
                        iconView = <View style={{ width: appTheme.pixelPerfect(56), height: appTheme.pixelPerfect(56), borderRadius: appTheme.pixelPerfect(28), backgroundColor: appTheme.daySkyColor, justifyContent: "center", alignItems: "center" }}>
                            <Image source={images.illSupercatStanding} style={{ width: appTheme.pixelPerfect(52), height: appTheme.pixelPerfect(52) }} resizeMode="contain" />
                        </View>;
                    }
                    cell.push(
                        <TouchableOpacity
                            accessibilityRole="button"
                            accessible={true}
                            accessibilityLabel={aCell.title}
                            onPress={() => openItem(aCell, isUserSubscriber)}
                            style={[{ width: cellWidth, justifyContent: "center", alignItems: 'center', borderRadius: appTheme.pixelPerfect(20), marginHorizontal: appTheme.pixelPerfect(5) }]}>
                            <View style={{ flexDirection: cellFlexDirection, width: cellWidth, minHeight: cellHeight, backgroundColor: backgroundColor, borderRadius: appTheme.pixelPerfect(20), alignItems: 'center', justifyContent: horizontalAlign, paddingHorizontal: appTheme.pixelPerfect(10), paddingTop: cellPaddingTop, paddingBottom: cellPaddingBottom }}>
                                {iconView}
                                <View style={{ padding: appTheme.pixelPerfect(10), justifyContent: 'center', flex: 1 }}>
                                    <Text style={{ textAlign: cellTextAlign, fontFamily: appTheme.secondaryFont, fontSize: cellTextFontSize, color: textColor }}>
                                        {aCell.title.toLocaleUpperCase()}
                                    </Text>
                                    {subtitleView}
                                    {subscribeButton}
                                </View>
                            </View>
                        </TouchableOpacity>
                    )
                }
            }
        }
        return <View style={{ flexDirection: "row", width: listWidth, justifyContent: "center", alignItems: "center", marginBottom: appTheme.pixelPerfect(10) }}>
            {cell}
        </View>;
    }

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    }

    const onSignOutRequest = () => {
        logout();
    }

    const logout = async () => {
        try {
            if ((user.tne_ido !== undefined) && (user.tne_ido.length > 0)) {
                const logoutUrl = await logoutGARUser();
                /*
                if (await InAppBrowser.isAvailable()) {
                    const result = await InAppBrowser.open(logoutUrl, {
                        // options
                        ephemeralWebSession: true, // recommandé sur iOS pour GAR (sécurisé)
                    });
                } else {
                    // fallback - browser classique
                    Linking.openURL(logoutUrl);
                }
                    */
            }
            await signOut();
            console.log("1")
            await wipeLocalStorage();
            console.log("2")
            revokeDBListeners();
            console.log("3")
            await wipeData();
            console.log("4")
            logoutUser();
            console.log("5")
            Navigation.relaunchApp({
                componentId,
                navigate
            });
        } catch (error) {
            console.log({ error });
            Navigation.relaunchApp({
                componentId,
                navigate
            });
        }
    }

    useEffect(() => {
        if (premiumCode.length > 0) {
            if (showPremiumCardForm === false) {
                setShowPremiumCardForm(true);
            }
        }
    }, [premiumCode]);

    const onViewDidAppear = async () => {
        if (viewDidAppear === false) {
            trackEvent(analyctisEventPageViewed, { [propertiesEventScreenLabel]: "user_profile" })
        }
        checkSub();
        getMood();
        await getActiveFiltersByLevel();
        if ((props.path !== undefined) && (props.path.length > 0)) {
            if (props.path === "sub") {
                openItem({ id: "account" }, false);
            } else if (props.path.includes("cardActivation")) {
                const pathArray: string[] = props.path.split("/");
                if (pathArray[pathArray.length - 1] !== "cardActivation") {
                    setPremiumCode(pathArray[pathArray.length - 1]);
                } else {
                    setShowPremiumCardForm(true);
                }
            }
        }
        setViewDidAppear(true);
    }

    const getActiveFiltersByLevel = () => {
        setFilterByLevel({ filter: user.children_level ?? "cycle2", last_update: new Date().getTime() });
    }


    const renderAdminCell = () => {
        if ((userInstance.admin === true) || (userInstance.bizdev === true)) {
            return aboutCell({
                item: [{
                    id: 'admin',
                    title: i18n.t('profile.admin'),
                    icon: IcMask,
                    color: "#B11313"
                }], index: "admin"
            })
        }
        return <View />
    }

    const getProfileContent = () => {
        if (viewDidAppear === false) {
            return <ActivityIndicator color={appTheme.darkBlue} />
        }
        if ((host === "app-tne.lili.cool") || (host === "app-tne-pp.lili.cool") || (host === "app-tne-demo.lili.cool")) {
            return <View style={{ width: listWidth, justifyContent: "flex-start", alignItems: "center" }}>
                <AccountCell />
                {aboutCell({
                    item: [{
                        id: 'filtersByLevel',
                        title: i18n.t('profile.filtersByLevelTeachers'),
                        icon: IcFilter,
                        color: appTheme.schoolColor
                    }], index: "filtersByLevel"
                })}
            </View>
        }
        const mainViewAlignItems = appTheme.getFlexDirectionForSplitScreen() === "row" ? "flex-start" : "center";
        const secondColumnPaddingTop: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? 0 : 0;
        const downloadRow: React.JSX.Element | null = Platform.OS === "web" ? null : aboutCell({ item: [downloadCell], index: "download" });
        const favoriteRow: React.JSX.Element | null = Platform.OS === "web" ? null : aboutCell({ item: [favoritesCell], index: "favorites" });

        let menuContent: React.JSX.Element = <View style={{ flex: 1, alignItems: mainViewAlignItems, width: appTheme.getFullAppWidth(), justifyContent: "center", flexDirection: appTheme.getFlexDirectionForSplitScreen() }}>
            <View style={{ width: listWidth, justifyContent: "flex-start", alignItems: "center" }}>
                <AccountCell />
            </View>
            <View style={{ width: listWidth, justifyContent: "flex-start", alignItems: "center", paddingTop: secondColumnPaddingTop }}>
                {aboutCell({
                    item: [{
                        id: 'filtersByLevel',
                        title: user.profile === "teacher" ? i18n.t('profile.filtersByLevelTeachers') : i18n.t('profile.filtersByLevel'),
                        icon: IcFilter,
                        color: appTheme.schoolColor
                    }], index: "filtersByLevel"
                })}
                {favoriteRow}
                {downloadRow}
                {renderAdminCell()}
                <View style={{ width: listWidth, alignItems: "center", justifyContent: "center", flexDirection: "row" }}>

                </View>
            </View>
        </View>;

        if ((user.tne_ido !== undefined) && (user.tne_ido.length > 0)) {
            // Utilisateur mobile TNE
            menuContent = <View style={{ flex: 1, alignItems: mainViewAlignItems, width: appTheme.getFullAppWidth(), justifyContent: "center", paddingTop: appTheme.pixelPerfect(10), flexDirection: appTheme.getFlexDirectionForSplitScreen() }}>
                <AccountCell />
                <View style={{ width: listWidth, justifyContent: "flex-start", alignItems: "center", paddingTop: secondColumnPaddingTop }}>
                    {aboutCell({
                        item: [{
                            id: 'filtersByLevel',
                            title: user.profile === "teacher" ? i18n.t('profile.filtersByLevelTeachers') : i18n.t('profile.filtersByLevel'),
                            icon: IcFilter,
                            color: appTheme.schoolColor
                        }], index: "filtersByLevel"
                    })}
                    {favoriteRow}
                    {downloadRow}
                </View>
            </View>
        }


        if (Platform.OS === "web") {
            return menuContent;
        }
        return <View style={{ width: appTheme.getFullAppWidth(), flex: 1 }}>
            {menuContent}
        </View>

    }

    const redeemedCard = async () => {
        // On va récupérer le détail de la carte et la valider
        setPremiumCodeError("");
        try {
            if (premiumCode.length > 0) {
                const card: PremiumCard = await getCardWithCode({ code: premiumCode });
                if (card === undefined) {
                    setPremiumCodeError("Aucune carte PREMIUM ne correspond à ce code.");
                } else {
                    if (card.status !== "toBeRedeemed") {
                        setPremiumCodeError("Ce code a déjà été utilisé.");
                    } else {
                        // On va ajouter l'abonnement à l'utilisateur
                        await addSubToUser({ user_id: userInstance.uid, sub_id: card.product_id, duration_in_month: card.duration, origin: card.origin, card_id: card.code, offer: card.offer });
                        await redeemedPremiumCardInDb({ card, user: userInstance });
                        setPremiumCodeRedeemed(true);
                    }
                }
            } else {
                setPremiumCodeError("Veuillez saisir un code");
            }
        } catch (error) {
            setPremiumCodeError("Une erreur est survenue")
        }
    }

    const getCardDetailsModalContent = () => {
        if (showPremiumCardForm === false) {
            return <View />
        }
        const cardTitle = i18n.t("subCards.modal.form.title");
        if (premiumCodeRedeemed === true) {
            return <View style={{ flex: 1, width: appTheme.getFullAppWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                    <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{i18n.t("subCards.modal.form.redeemed")}</Text>
                    <Button
                        link={true}
                        isLoading={isLoading}
                        onPress={() => setShowPremiumCardForm(false)}
                        title={i18n.t("subCards.modal.form.close")}
                        style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                </View>
            </View>;
        }
        if (userInstance.getPremiumStatus() === "free") {
            let cardSubtitle = i18n.t("subCards.modal.form.body");
            let closeButtonTitle = i18n.t("subCards.modal.form.nothingToDo");
            const errorTextView = premiumCodeError.length === 0 ? <View /> : <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.errorColor, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{premiumCodeError}</Text>;
            return <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                    <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardSubtitle}</Text>
                    <TextInput value={premiumCode} onChangeText={(text) => setPremiumCode(text)} style={{ width: appTheme.pixelPerfect(200) }} />
                    {errorTextView}
                    <Button
                        isLoading={isLoading}
                        onPress={() => redeemedCard()}
                        title={i18n.t("subCards.modal.form.active")}
                        style={{ width: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                    <Button
                        link={true}
                        isLoading={isLoading}
                        onPress={() => setShowPremiumCardForm(false)}
                        title={closeButtonTitle}
                        style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
                </View>
            </View>;
        }
        return <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), backgroundColor: "#00000090", alignItems: "center", justifyContent: "flex-end" }}>
            <View style={[Style.shadowed, { paddingVertical: appTheme.pixelPerfect(30), paddingHorizontal: appTheme.pixelPerfect(20), width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white, alignItems: "center", justifyContent: "flex-end", borderTopEndRadius: appTheme.pixelPerfect(10), borderTopStartRadius: appTheme.pixelPerfect(10) }]}>
                <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), color: appTheme.darkBlue, paddingVertical: appTheme.pixelPerfect(10), textAlign: "center" }}>{cardTitle}</Text>
                <Text style={{ fontFamily: appTheme.secondaryFont, fontSize: appTheme.pixelPerfectForFont(10), color: appTheme.darkBlue, paddingBottom: appTheme.pixelPerfect(10), textAlign: "center" }}>{i18n.t("subCards.modal.already")}</Text>
                <Button
                    link={true}
                    isLoading={isLoading}
                    onPress={() => setShowPremiumCardForm(false)}
                    title={i18n.t("subCards.modal.form.close")}
                    style={{ minWidth: appTheme.pixelPerfect(200), marginBottom: appTheme.pixelPerfect(20) }} />
            </View>
        </View>;
    }

    const showAboutPage = () => {
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenAbout,
            passProps: {
                isTeacher: true
            }
        });
    }

    const aboutImageSize: number = appTheme.pixelPerfect(44);

    const mainOptions: MainOptions = new MainOptions({
        key: "user_profile",
        componentId,
        showNavBar: false,
        showMenu: false,
        canGoBack: false,
        safeArea: false
    });


    const deleteRow: React.JSX.Element = Platform.OS === "web" ? <View /> : aboutCell({ item: [deleteAccountCell], index: "delete" });

    return (
        <Main mainOptions={mainOptions}>
            <View style={{ alignItems: "center", justifyContent: "flex-start", backgroundColor: appTheme.getBackgroundColor(), flex: 1, width: appTheme.getFullAppWidth(), paddingBottom: appTheme.pixelPerfect(80) }}>
                <ScrollView showsVerticalScrollIndicator={false} style={{ marginTop: appTheme.topInsets }}>
                    <View style={{ width: appTheme.getFullAppWidth(), alignItems: "center" }}>
                        <NavBarTitle titleColor={user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue} title={i18n.t("profile.title")} showLevel={false} />
                        <View style={{ position: "absolute", top: appTheme.pixelPerfect(16), right: appTheme.pixelPerfect(10) }}>
                            <NavBarButton action={() => onSignOutRequest()} icon={IcSignOut} />
                        </View>
                    </View>
                    <View onLayout={onViewDidAppear} style={{ flex: 1, alignItems: "flex-start", width: appTheme.getFullAppWidth() }}>
                        {getProfileContent()}
                        <View style={{ flexDirection: appTheme.getFlexDirectionForSplitScreen() }}>
                            <View style={{ alignItems: "center", paddingBottom: appTheme.pixelPerfect(20), width: appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.getFullAppWidth() / 2 : appTheme.getFullAppWidth() }}>
                                {deleteRow}
                            </View>
                            <View style={{ flexDirection: "row", paddingBottom: appTheme.pixelPerfect(20), alignItems: "center", justifyContent: "center", width: appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.getFullAppWidth() / 2 : appTheme.getFullAppWidth() }}>
                                <TouchableOpacity onPress={showAboutPage} style={{ paddingTop: appTheme.pixelPerfect(4), width: aboutImageSize, height: aboutImageSize, borderRadius: aboutImageSize / 2, justifyContent: "center", alignItems: "center" }}>
                                    <Image source={images.icAbout} style={{ width: aboutImageSize, height: aboutImageSize }} />
                                </TouchableOpacity>
                                <TouchableOpacity style={{ width: aboutImageSize, height: aboutImageSize, justifyContent: "center", alignItems: "center" }} onPress={() => openUrl("https://www.lili.cool/fr/contact/")}>
                                    <View style={{ width: aboutImageSize - 20, height: aboutImageSize - 20, backgroundColor: appTheme.talk, borderRadius: (aboutImageSize - 20) / 2, justifyContent: "center", alignItems: "center" }}>
                                        <SVGView Component={IcArobas} size={(aboutImageSize - 20) / 2} color="#FFFFFF" />
                                    </View>
                                    <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_plane.png")} style={{ width: aboutImageSize / 2, height: aboutImageSize / 2, position: "absolute", bottom: 0, right: 0 }} />
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                </ScrollView>
                <UserLevelSelection
                    visible={showFilters}
                    style={{ flex: 1, justifyContent: "flex-end" }}
                    backgroundColor={appTheme.schoolColor}
                    toggleFilters={toggleFilters} />
                <Modal
                    style={{ flex: 1 }}
                    transparent={true}
                    presentationStyle="overFullScreen"
                    animationType="slide"
                    visible={showPremiumCardForm}>
                    <View style={{ flex: 1, width: appTheme.getFullScreenWidth(), alignItems: "center", justifyContent: "center" }}>
                        {getCardDetailsModalContent()}
                    </View>
                </Modal>
                <Alert ref={alertRef} />
            </View>
        </Main>
    )
}

export default UserProfile;

const styles = StyleSheet.create({
    logoutButton: {
        justifyContent: "center",
        alignItems: "center"
    },
    cell: {
        backgroundColor: "#FFFFFF",
        padding: 10
    }
});